<template>
  <div :class="wrapperClasses">
    <!-- Default dashboard and coach AI items -->
    <DefaultNavigationItems
      v-if="showDashboard || showCoachAI"
      :showDashboard="showDashboard"
      :showCoachAI="showCoachAI"
      :expanded="expanded"
      :isHorizontal="!isVertical"
      :selectedItem="selectedItem"
      @setSelectedItem="onSelectItem"
    />

    <div class="mx-2 my-2 hidden border-t border-white/20 md:block" />

    <!-- Regular navigation items -->
    <NavigationPaneList
      :items="items"
      :expanded="expanded"
      :position="position"
      :selectedItem="selectedItem"
      :isMobileNav="isMobileNav"
      @selectItem="onSelectItem"
    >
      <template v-for="navItem in items" :key="navItem.id" #[`icon-${navItem.id}`]="{ item }">
        <slot :name="`icon-${navItem.id}`" :item="item">
          <component :is="item.icon" v-if="item.icon" />
        </slot>
      </template>
    </NavigationPaneList>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { type Position, type NavItem } from '../types/NavigationPane'
import NavigationPaneList from './NavigationPaneList.vue'
import DefaultNavigationItems from './DefaultNavigationItems.vue'
import { cn } from '../utils/navigationClasses'

export default defineComponent({
  name: 'NavigationWrapper',
  components: {
    NavigationPaneList,
    DefaultNavigationItems
  },
  props: {
    items: {
      type: Array as () => NavItem[],
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    position: {
      type: String as () => Position,
      default: 'left'
    },
    selectedItem: {
      type: String,
      default: undefined
    },
    showDashboard: {
      type: Boolean,
      default: true
    },
    showCoachAI: {
      type: Boolean,
      default: true
    },
    isMobileNav: {
      type: Boolean,
      default: false
    }
  },
  emits: ['selectItem'],
  setup(props, { emit }) {
    const onSelectItem = (id: string) => {
      emit('selectItem', id)
    }

    const isVertical = computed(() => props.position === 'left' || props.position === 'right')

    const wrapperClasses = computed(() => {
      return cn('flex w-full', {
        'flex-col': isVertical.value,
        'flex-row': !isVertical.value,
        'h-full': isVertical.value,
        'w-full': !isVertical.value,
        'justify-center': !isVertical.value
      })
    })

    return {
      onSelectItem,
      wrapperClasses,
      isVertical
    }
  }
})
</script>
